import { Card } from "components/ui/card";
import { Button } from "components/ui/button";
import { Progress } from "components/ui/progress";
import { X } from "lucide-react";
import { formatBytes } from "utils/commons";
import { UploadProgressMap } from "pages/geoscape-admin/custom-datasets/custom-hook/types";
import { FileWithPath } from "react-dropzone";

export interface FileUploadProgressProps {
  uploadProgress: UploadProgressMap;
  file: FileWithPath;
  onRemove: (fname: string) => void;
  isUploading: boolean;
  haveUploaded: boolean;
}

export const FileUploadProgress = (props: FileUploadProgressProps) => {
  const progress = props.file.path
    ? props.uploadProgress[props.file.path]
    : undefined;
  const isComplete = progress?.percentComplete === 100;
  const showProgress =
    (props.isUploading || props.haveUploaded) && props.file.path && progress;

  return (
    <Card
      key={props.file.path}
      className="flex flex-row items-start gap-2 p-2 mt-2"
    >
      <div className="flex-1 min-w-0">
        <p className="truncate">{props.file.path}</p>
        {showProgress ? (
          <>
            <p className="text-muted-foreground text-xs">
              {formatBytes(props.file.size)} -{" "}
              {isComplete
                ? "COMPLETE"
                : `about ${progress.humanisedTimeRemaining} remaining`}
            </p>
            <Progress
              value={progress.percentComplete}
              className={isComplete ? "[&>[data-slot=progress-indicator]]:bg-green-600" : undefined}
            />
          </>
        ) : (
          <p className="text-muted-foreground text-xs">
            {formatBytes(props.file.size)}
          </p>
        )}
      </div>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => props.onRemove(props.file.name)}
        aria-label="Remove file"
      >
        <X />
      </Button>
    </Card>
  );
};
